
import React, { Fragment,useEffect } from 'react';
import styles from '../../styles/modules/components/SelfServe/service-request-success.module.scss';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import Button from "../common/ui-components/input/Button";
import { QueryForm } from './QueryForm';
import { useState } from 'react';
import UIModal from '../common/ui-components/surface/UIModal';
import modalStyles from '../../styles/modules/components/SelfServe/selfserve-modal.module.scss';
import { connect } from 'react-redux';
import Image from '../common/Image';
import { getStaticPath } from "../../utils";
import { Hidden } from '@mui/material';
import { chatWithUsModal, failurePage } from '../../tracking/selfserveTracking';
import { getPageURL } from '../../utils/tracking';
import { chatbotClicked } from '../../tracking/segment/footer';


interface ReduxStateProps {
    selfserveReducer: any,
}

interface MainProps {
    subIssues: any,
}

type Props = ReduxStateProps & MainProps

const ServiceRequestFailure = (props: Props) => {

    useEffect(() => {
        failurePage(); //gtm trackign event

        window.scrollTo({top:0,left:0,'behavior': 'smooth'});

    }, [])
    const [open, changeOpen] = useState(false);

    const close = () => {
        changeOpen(false)
        return false
    }
    const openChat = () => {
        chatWithUsModal('SR Failure Page'); //gtm tracking event
        // event.preventDefault()
        changeOpen(false)
        chatbotClicked({...getPageURL()})
        window.open(`https://onst.in/4dCuJA`, "noopener,noreferrer")
        window.opener = null
    }

    const failureReasons = props.selfserveReducer.failureData.error


    const raiseQuery = () => {
        changeOpen(true);
    }

    return (
        <Fragment>
            <div className={styles.container}>

                <div className={styles._img}>
                    <Image src={getStaticPath(`/static/images/selfserve/failure.png`)} quality={100} alt="Success" width="100" height="100" unoptimized={true}/>
                </div>

                <h5 data-varient='failure'>Unable to create the service request</h5>

                <div className={styles.container_head}>
                    <p><span>Reasons for failures:</span></p>
                </div>

                <div className={styles.container_content}>


                    <div className={styles.reasons_parent}>
                        {
                            failureReasons && failureReasons.map((reason, i) =>
                                <div className={styles.reasons} key={i}>
                                    {reason}
                                </div>

                            )
                        }
                    </div>

                    <p className={styles.assistance}>Would you need any assistance to create the service request?</p>

                </div>

                <Hidden smUp>

                    <div className={commonStyles.single_button} style={{'marginTop': '20px'}} data-varient='non-sticky'>

                        <Button
                            text="Raise Query"
                            onClick={() => raiseQuery()}
                            className={commonStyles.single_btn}
                            variant="secondary"
                        />
                        <Button
                            text="Chat with us"
                            onClick={openChat}
                            className={commonStyles.single_btn}
                        />
                    </div>

                </Hidden>

                <Hidden smDown>
                    <div className={commonStyles.button_actions_sticky} style={{'marginTop': '20px'}} data-varient='non-sticky'>

                        <Button
                            text="Raise Query"
                            onClick={() => raiseQuery()}
                            className={commonStyles.cart_btn}
                            variant="secondary"
                        />
                        <Button
                            text="Chat with us"
                            onClick={openChat}
                            className={commonStyles.cart_btn}
                        />
                    </div>
                </Hidden>

            </div>
            {open &&
                <UIModal isOpen={open} onClick={close} boxClass={modalStyles.apply_box} larger={false}>
                    <div>

                        <QueryForm onClose={close} subIssues={props.subIssues} />
                    </div>
                </UIModal>
            }

        </Fragment>
    );

}

const mapStateToProps = (state: any) => {
    return {
        selfserveReducer: state.selfserveReducer,
    }
}

export default connect<ReduxStateProps>(mapStateToProps) (ServiceRequestFailure);